import styled from 'styled-components';

export const Indicator = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 21;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 2px solid
    ${({ $selected }) => ($selected ? 'var(--bs-primary)' : 'rgba(255, 255, 255, 0.95)')};
  border-radius: 50%;
  color: #ffffff;
  background-color: ${({ $selected }) =>
    $selected ? 'var(--bs-primary)' : 'rgba(18, 14, 2, 0.32)'};
  box-shadow: 0 1px 5px rgba(18, 14, 2, 0.25);
  transform: ${({ $selected }) => ($selected ? 'scale(1)' : 'scale(0.94)')};
  transition:
    background-color 180ms cubic-bezier(0.2, 0, 0, 1),
    transform 180ms cubic-bezier(0.2, 0, 0, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
